import { User } from 'oidc-client-ts';
import {
  api,
  store,
  navConfig, ENavPages,
  setActivePortalDealer,
  getCurrentBaseDomain,
  isDevelopmentEnv,
  addAlert,
  redirectToLogin,
  redirectToLogout,
  clearAllAuthValues,
  addPendingRedirect,
  partnerKey,
  updateCanUserCreateDealer,
  getPendingAdminInvitePath,
} from '../../internal';

// export const handleCachedContinueTo = (): boolean => {
//   // if they user is verified, send the user to the landing default page
//   // using this instead of history since history is not able to
//   // remove the query parameters returned by the OIDC response.
//   const cachedContinueTo = api.cacheImpl.get('continueTo');
//   api.cacheImpl.remove('continueTo');

//   // only send to dealer creation if the user is not intending to view a dealer invitation
//   const currentlyNotOnInvitesPage = !/\#\/invites/.test(window.location.hash);
//   const cacheNotPointingToInvitesPage = !/\/invites/.test(cachedContinueTo);
//   if (currentlyNotOnInvitesPage) {

//     if (cacheNotPointingToInvitesPage) {
//       store.dispatch(addPendingRedirect({ 
//         pathname: navConfig.get(ENavPages.dealerCreate)!.linkTo(),
//         priority: 'high'
//       }));
//       return true;
//     } else {
//       // not on the invites page and the cache says to go there, navigate to the invite page.
//       const goToLoc = `${getCurrentBaseDomain()}#${cachedContinueTo}`;
//       store.dispatch(addPendingRedirect({ fullUrl: goToLoc, priority: 'high' }));
//       return true;
//     }
//   }
//   return false; // let callers know the portal has not been redirected
// }


export const tokenRefreshDealerPortalBusiness = async (decoded: any): Promise<void> => {
    // at this point the api already has the auth token set
    const authUser = await api.getAuthUser();
    const canUserCreateDealers = decoded?.create_dealer?.toLowerCase() === partnerKey.toLowerCase();
    api.setCanCreateDealer(authUser.id, canUserCreateDealers);
    store.dispatch(updateCanUserCreateDealer(canUserCreateDealers));

    const cacheContinueToValue = decodeURIComponent(api.cacheImpl.get('continueTo'));
    // only send to dealer creation if the user is not intending to view a dealer invitation
    const currentlyOnWalletPage = /\#\/wallet/.test(window.location.hash);
    const currentlyOnInvitesPage = /\#\/invites/.test(window.location.hash);
    const cacheIsPointingToInvitesPage = /\/invites/.test(cacheContinueToValue);
    const currentlyOnPortalPage = /\#\/portal/.test(window.location.hash);

    if ((currentlyOnInvitesPage && cacheIsPointingToInvitesPage)) {
      return;
    }

    if ((!currentlyOnInvitesPage && cacheIsPointingToInvitesPage)) {
      // not on the invites page and the cache says to go there, navigate to the invite page.
      // const goToLoc = `${getCurrentBaseDomain()}#${cacheContinueToValue}`;
      store.dispatch(addPendingRedirect({ pathname: cacheContinueToValue, priority: 'high'}));
      api.cacheImpl.remove('continueTo');
      return;
    }

    // no need to go to invites page, check for dealer.
    if (authUser.getDealer()?.id) {
      // there's a dealer - go to the landing page for the preferred dealer
      const dealer = authUser.getPreferredDealer(api.cacheImpl);
      if (dealer) {
        await store.dispatch(setActivePortalDealer(dealer));
        // default redirect should happen in splash catch-all
        // if (!currentlyOnPortalPage) {
        //   // only redirect the user if they're not already inside a portal page.
        //   store.dispatch(addPendingRedirect({ pathname: navConfig.get(ENavPages.portalLanding)!.linkTo(), priority: 'low'}));
        //   return;
        // }
      }
    }

    // a pending admin invite (stored apart from continueTo so it survives registration and
    // email verification) takes precedence over the default / dealer-creation routing.
    // it is cleared by the accept page once an authenticated user lands there.
    const pendingAdminInvitePath = getPendingAdminInvitePath();
    if (pendingAdminInvitePath) {
      if (!currentlyOnInvitesPage) {
        store.dispatch(addPendingRedirect({ pathname: pendingAdminInvitePath, priority: 'high' }));
      }
      return;
    }

    if (!authUser.getDealer()?.id && !(currentlyOnInvitesPage || currentlyOnWalletPage)) {
      // if the auth user does not have a dealer association, send them to dealer creation.
      // skip this when the user is on an invite-accept or wallet-accept page so a refresh there keeps
      // them in place instead of bouncing them to dealer creation.
      store.dispatch(addPendingRedirect({ pathname: navConfig.get(ENavPages.dealerCreate)!.linkTo() }));
      return;
    }
};